<app-bread-crumb [items]="[{text:  'clubes',link:'/admin/clubs'},{text:pageTitle}]"
  [sectionTitle]="pageTitle"></app-bread-crumb>

  <section class="content">

    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

        <!-- inicio do box -->
    <ng-box [boxIcon]="'fa fa-soccer-ball-o'" [boxTitle]="'Dados Clube'" [showBoxFooter]="true">

         <!-- cabesalho -->
         <ng-container class="ng-box-header">
            <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}"></ng-button>
        </ng-container>

        <!-- conteudo do box -->
        <ng-container class="ng-box-content">

          <div class="row">

            <div class="col-md-6">

              <div class="form-group">

                <app-input label="Nome(*)" errorMessage="Campo obrigatório">
                  <input type="text" formControlName="name" class="form-control">
                </app-input>

              </div>

            </div>

            <div class="col-md-6">

              <div class="form-group">

                <app-input label="Email(*)" errorMessage="- Campo obrigatório; - Introduza um email válido;">
                  <input type="email" formControlName="email" class="form-control">
                </app-input>
                
              </div>

            </div>
            <!-- <div class="col-md-4">

              <div class="form-group">

                <app-input label="Logotipo(*)" errorMessage="Campo obrigatório">
                  <div class="upload-btn-wrapper">
                    <button class="btn btn-outline-danger btn-block">
                      <i class="fa fa-cloud-upload"></i> Clique aqui para carregar o logotipo
                    </button>
                    <input type="file" #iptFile formControlName="phot"/>
                    <small class="text-primary">{{ iptFile?.files[0]?.name }}</small>
                  </div>
                  <input  type="file" #img formControlName="phot" class="form-control">
                </app-input> 
                
              </div>


            </div> -->

          </div>

          <div class="row">

            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Cor Predominante(*)" errorMessage="Campo obrigatório">
                  <input type="text" #iptColor formControlName="color" [(ngModel)]="iptColor.value || object.color"  class="form-control my-colorpicker1">
                </app-input>
                
              </div>

            </div>
            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Telefone(*)" errorMessage="- Campo obrigatório;- Introduza um telefone válido;- Mínimo 9 Dígitos, Maxímo 14 Dígitos;">
                  <input type="text" formControlName="phone" class="form-control">
                </app-input>

              </div>

            </div>

            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Nuit(*)" errorMessage="- Campo obrigatório; - Somente números são aceites; Maxímo 9 Dígitos;">
                  <input type="text" formControlName="nuit" class="form-control">
                </app-input>
                
              </div>

            </div>

          </div>

          <div class="row">
            <div class="col-md-12">
              <span *ngIf="iptColor.value" [ngStyle]="{backgroundColor:iptColor.value,color:'white'}" class="form-control text-center">Cor Predominante!</span>
            </div>
          </div>
          <div class="row">
            
            <div class="col-md-6">

              <div class="form-group">

                <app-input label="Endereço(*)" errorMessage="Campo obrigatório">
                  <input type="text" formControlName="address" class="form-control">
                </app-input>
                
              </div>


            </div>

            <div class="col-md-6">

              <div class="form-group">

                <app-input label="Provincia(*)" errorMessage="Campo obrigatório">

                  <select formControlName="cities_id" class="form-control">
                    <option value="1">Maputo Cidade</option>
                    <option value="2">Maputo Provincia</option>
                    <option value="3">Gaza</option>
                    <option value="4">Inhambane</option>
                    <option value="5">Manica</option>
                    <option value="6">Sofala</option>
                    <option value="7">Tete</option>
                    <option value="8">Zambezia</option>
                    <option value="9">Nampula</option>
                    <option value="10">Niassa</option>
                    <option value="11">Cabo Delgado</option>
                  </select>

                </app-input>
                
              </div>

            </div>


            
          

          </div>
          
          <fieldset>
            <legend>Dados de Representante</legend>
          </fieldset>
          <div class="row">
 
            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Nome(*)" errorMessage="Campo obrigatório">
                  <input type="text" formControlName="responsible_name" class="form-control">
                </app-input>

              </div>

            </div>
            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Email" errorMessage="Introduza um email válido">
                  <input type="text" formControlName="responsible_email" class="form-control">
                </app-input>

              </div>

            </div>

            <div class="col-md-4">

              <div class="form-group">

                <app-input label="Telefone" errorMessage="- Introduza um telefone válido;- Mínimo 9 Dígitos, Maxímo 14 Dígitos;">
                  <input type="text" formControlName="responsible_phone" class="form-control">
                </app-input>

              </div>

            </div>


           

          </div>
        
      </ng-container>

      <!-- fim do conteudo do box -->

      <!-- rodapé -->
      <ng-container class="ng-box-footer">
        <div class="row">
          <div class="col-xs-12">
            <ng-button  *ngIf="isAdminOrUserKhuzela() " class="pull-right" [button]="{
                name:'salvar',
                color:'danger',
                faIconClass:'fa fa-save',
                type:'submit',
                loadingText:'SALVANDO',
                isLoading:isButtonLoading,
                isDisabled:isButtonLoading || objectForm.invalid}">
            </ng-button>

          </div>
        </div>
      </ng-container>


    </ng-box>
    <!-- fim do box -->
  </form>
  <!-- fim do formulario -->

  </section>